import React, { useEffect } from "react";

import { Icon } from "../components/icon/icon.component";
import { CircularProgress } from "@mui/material";

const Page403Forwarder = (props) => {
  useEffect(() => {
    console.log("403 Forwarder rendered");
    if (props?.forward) {
      setTimeout(() => {
        window.location.replace(`${props.forward}`);
      }, 3000);
    }
  }, []);

  return (
    <div className="wrapper">
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center", //
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "25px" }}>
          <Icon name="fa-solid-exclamation-triangle" size={24} />
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "20px",
            marginBottom: "20px",
          }}
        >
          You don't have permission to view this site. Returning to
          marketing.cinch.io...
        </div>
        <CircularProgress />
      </div>
    </div>
  );
};

export default Page403Forwarder;
